import SubMenu, { SubMenuTitle } from 'components/SubMenu';
import Routes from 'constants/Routes';
import Roles, {
  includesRoles,
  TruckShareTargetViewAccessPolicy,
} from 'constants/Roles';
import useMe from 'contexts/authentication/useMe';
import useHasAccessToRoutePlanningSettings from 'hooks/useHasAccessToRoutePlanningSettings';
import { FC } from 'react';
import { Outlet } from 'react-router-dom';
import styled from 'styled-components';
import { arraySpreadIf } from 'utils/spreading';

const Wrapper = styled.div``;

const SettingsPage: FC = () => {
  const me = useMe();
  const isSuperAdmin = includesRoles([Roles.SuperAdmin], me?.roles);
  // Hemankare och ruttprov ligger under fliken Ruttplanering, som styrs per användare (116).
  const canSeeRoutePlanningSettings = useHasAccessToRoutePlanningSettings();
  const canSeeTruckShareTarget = includesRoles(
    TruckShareTargetViewAccessPolicy.allow,
    me?.roles
  );

  return (
    <Wrapper>
      <SubMenu
        items={[
          {
            label: <SubMenuTitle>Helgdagar</SubMenuTitle>,
            path: Routes.settings.holidays,
          },
          {
            label: <SubMenuTitle>Områden</SubMenuTitle>,
            path: Routes.settings.zipCodeAreas,
          },
          {
            label: <SubMenuTitle>Enheter</SubMenuTitle>,
            path: Routes.settings.businessUnits,
          },
          {
            label: <SubMenuTitle>Standardiserade kommentarer</SubMenuTitle>,
            path: Routes.settings.standardizedComments,
          },
          {
            label: <SubMenuTitle>Produkt-kostnadstyper</SubMenuTitle>,
            path: Routes.settings.productExpenseTypeMappings,
          },
          {
            label: <SubMenuTitle>Avdelningar</SubMenuTitle>,
            path: Routes.settings.companyDepartments,
          },
          {
            label: <SubMenuTitle>Globala inställningar</SubMenuTitle>,
            path: Routes.settings.globalSettings,
          },
          {
            label: <SubMenuTitle>Skiftespunkter</SubMenuTitle>,
            path: Routes.settings.driverSwapPoints,
          },
          {
            label: <SubMenuTitle>Fordonsklassificering</SubMenuTitle>,
            path: Routes.settings.vehicleClassification,
          },
          ...arraySpreadIf(isSuperAdmin, {
            label: <SubMenuTitle>Estimattider</SubMenuTitle>,
            path: Routes.settings.estimateDurations,
          }),
          ...arraySpreadIf(canSeeTruckShareTarget, {
            label: <SubMenuTitle>Annons: lastbil/FT</SubMenuTitle>,
            path: Routes.settings.truckShareTarget,
          }),
          ...arraySpreadIf(canSeeRoutePlanningSettings, {
            label: <SubMenuTitle>Ruttplanering</SubMenuTitle>,
            path: Routes.settings.routePlanning.index,
            matchPrefix: true,
          }),
        ]}
      />
      <Outlet />
    </Wrapper>
  );
};

export default SettingsPage;
